<template>
  <!-- <div class="intl-tel-input allow-dropdown"> -->
  <!-- <div class="flag-container"> -->
  <!-- <div class="selected-flag" :title="currentData.name + ': +' + currentData.dialCode">
        <div :class="'iti-flag ' + currentData.code" />
        <div class="iti-arrow" />
      </div>-->
  <ul class="country-list">
    <li
      v-for="item in lanList"
      :key="item.no+Math.random()*10"
      :class="item.name === currentName? 'country sy-cell_between highlight' : 'country sy-cell_between'"
      @click="showChose(item)"
    >
      <!-- <div class="flag-box">
            <div :class="'iti-flag ' + item.code" />
          </div>-->
      <span class="country-name">{{ item.name }}</span>
      <span class="dial-code">+{{ item.no }}</span>
    </li>
  </ul>
  <!-- </div> -->
  <!-- <span class="area-codeNum" :title="currentData.name + ': +' + currentData.dialCode" :style="fontFamily='ArialMT'" @click="hideSubMenu = !hideSubMenu">{{ "+"+currentData.dialCode }}</span> -->
  <!--<input type="tel" v-bind:value="value" class="form-control" autocomplete="off" :placeholder="'+'+currentData.dialCode">-->
  <!-- </div> -->

</template>
<script>
import countrieszh from './county-zh'
import countriesen from './county-en'
import { getLanguage } from '../../lang/index'
var countries = getLanguage() === 'zh' ? countrieszh : countriesen
import { getCountries } from '@/api/login'
var lan = getLanguage() ? getLanguage() : 'en'
export default {
  name: 'InitPhone',
  props: {
    hideSubMenu: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      currentName: this.$store.state.initTelphone.name,
      lan: lan,
      lanList: [],
      // hideSubMenu: true,
      show: true
    }
  },
  computed: {
    countriesArray() {
      const countryCopie = { ...countries }
      if (this.hideSubMenu) {
        delete countryCopie.cn
      }
      return countryCopie
    }
  },
  created() {
    getCountries({ lan: this.lan }).then(res => {
      this.lanList = res.data.data
      this.$store.dispatch('setInitTelphone', this.lanList[0])
    })
  },
  methods: {
    showChose(item) {
      this.currentCode = item.code
      // var telPhoneSelect = countries[this.currentCode]
      this.$store.dispatch('setInitTelphone', item)
      this.currentName = item.name
      console.log(this.$store.state)
      this.$parent.$parent.show = false
      // this.$router.go(-1)
    }
  }
}
</script>
<style scoped  lang="scss">
  // .allow-dropdown {
  // /* height: 50%; */
  // display: flex;
  // padding: 10px 15px;
  // align-items: center;
  // overflow-y: auto;
  // height: 70vh;

  // .flag-container {
  // position: relative;
  // height: 100%;
  .country-list {
    width: 100vw;
    height: 70vh;
    padding: 10px 15px;

    // z-index: 10;
    // position: absolute;
    // left: 0;
    // top: .3rem;
    // padding: .1rem .2rem;
    list-style: none;
    // width: 6rem;
    // height: 5.5rem;
    overflow: auto;
    // background: #ffffff;

    li {
      height: 40px;
      font-size: 16px;
      line-height: 40px;
      border-bottom: 1px solid #ececec;
      color: #333;
      //   padding:12px 0;
      .dial-code {
        color: #ccc;
        // font-weight: bold;
      }
    }
    .highlight{
      font-weight: bold;
      color:#F18937;
      .dial-code {
        color: #F18937;
        font-weight: bold;
      }
    }
  }
  // }

  .area-codeNum {
    font-family: "ArialMT";
    padding: 0.1rem 0.1rem;
    margin-left: 0.2rem;
    display: inline-block;
    font-size: 0.26rem;
    align-self: start;
    flex: 1;

    &::after {
      border-width: 5px;
      border-style: solid;
      border-color: #000 transparent transparent;
      content: "";
      width: 0;
      height: 0;
      position: relative;
      top: 0.25rem;
      left: 0.15rem;
    }
  }
  // }

</style>
